"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FishermanBanner;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _fishermanLogo = _interopRequireDefault(require("./fisherman-logo.svg"));
require("./FishermanBanner.css");
function FishermanBanner(props) {
  var backgroundColor = props.backgroundColor;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fisherman-banner",
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://gofisherman.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Powered by"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    className: "fisherman-logo",
    src: _fishermanLogo["default"]
  })));
}
FishermanBanner.propTypes = {
  backgroundColor: _propTypes["default"].string
};
FishermanBanner.defaultProps = {
  backgroundColor: 'black'
};